export { ModalNovaMatricula } from './modal-nova-matricula'
export * from './tipos'
